import { Container, Row, Col, Typo } from '@geberit/gdds';

// style
import styles from './video.module.scss';

// types
import type { VideoProps } from './video.types';

// components
import { InnerHtml } from 'components/InnerHtml/inner-html';
import { Headline, Formats, getFontWeight } from 'components/ContentElements/Headline';
import { MiVideoContainer } from 'components/Video/miVideo/MiVideoContainer';

// utils
import { textStyle } from './styles';
import { classNameBuilder } from 'utils/classNameBuilder';
import { decodingContent } from 'utils/decodingContent';
import { useThemeName } from 'utils/hooks/use-theme';
import { useSectionId } from 'utils/hooks/use-section-id';

export function Video({
  video,
  title,
  subtitle,
  emphasize,
  caption,
  text,
  contentIndex,
  spacing,
  backgroundColor,
}: Readonly<VideoProps>) {
  const themeName = useThemeName();
  const sectionId = useSectionId(title, '', false, contentIndex);

  return (
    <div
      className={classNameBuilder(
        styles.video,
        spacing?.top === 'small' && styles.marginTopSmall,
        spacing?.bottom === 'small' && styles.marginBottomSmall,
        styles[`${backgroundColor}Background`],
      )}
      id={sectionId}
    >
      <Container maxContentWidth="52.5rem">
        <Row>
          <Col>
            <Headline
              title={title}
              subtitle={subtitle}
              format={Formats.h2}
              titleFontWeight={getFontWeight(emphasize === 'title', themeName, Formats.h2)}
              subtitleFontWeight={getFontWeight(emphasize === 'subtitle', themeName, Formats.h2)}
              className={styles.headline}
              titlePreviewId="#st_title"
              subtitlePreviewId="#st_subtitle"
            />

            {text && (
              <Typo tag="div" fontWeight={400} size={textStyle.paragraph}>
                <InnerHtml
                  as="div"
                  content={text}
                  className={styles.text}
                  isGdds
                  previewId="#st_text"
                />
              </Typo>
            )}

            <div className={styles.player}>
              <MiVideoContainer content={{ video }} className="c-text-video" />
              {caption && (
                <Typo tag="div" size={textStyle.caption} className={styles.caption}>
                  {decodingContent(caption)}
                </Typo>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
